<!--
 * @Author: wang peng
 * @Description: 直联电桩列表  
-->
<template>
  <scroll-layout class="directConnectionPile-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())"
        :selectable="true"
        :operateButtonsSplitCount="4"
        :rowSelectable="row => true"
        :selectOnIndeterminate="false"
        @selection-change="selectionChange">
        <template #headerButtons>
          <div class="table-header-button">
            <template v-for="(btn, i) in pageButtons">
              <ykc-button
                v-if="i != 0 && btn.enabled()"
                :key="i"
                :type="btn.type"
                @click="btn.handleClick">
                {{ btn.text }}
              </ykc-button>
              <el-dropdown @command="handleCommand" v-if="i == 0 && btn.enabled()" :key="i">
                <ykc-button :type="btn.type" v-if="btn.enabled()">
                  {{ btn.text }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </ykc-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="'levelConfig'"
                    v-if="code('asset:station:diretpile:batchAdd')">
                    批量新增
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="'enable'"
                    v-if="code('asset:station:diretpile:batchEnable')">
                    批量启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="'disable'"
                    v-if="code('asset:station:diretpile:batchEnable')">
                    批量停用
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="'delete'"
                    v-if="code('asset:station:diretpile:batchDel')">
                    批量删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="'growthValueRule'"
                    v-if="code('asset:station:diretpile:batchTiming')">
                    校时/校价
                  </el-dropdown-item>
                  <el-dropdown-item :command="'clearOfflineCache'">一键清理缓存</el-dropdown-item>
                  <el-dropdown-item
                    :command="'publishQrCode'"
                    v-if="code('asset:station:diretpile:publishQrCode')">
                    二维码下发
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="'exportQrCode'"
                    v-if="code('asset:station:diretpile:exportQrCode')">
                    二维码导出
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
      <!-- 新增/编辑抽屉 -->
      <ykc-drawer
        :title="drawerTitle"
        :show.sync="showDrawer"
        :on-close="onAddDrawerClose"
        :before-cancel="onAddDrawerCancel">
        <template #footer>
          <div class="drawer-button-wrap">
            <template v-for="(btn, i) in drawerButtons">
              <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handler">
                {{ btn.label }}
              </ykc-button>
            </template>
          </div>
        </template>
        <div class="drawer-main-body" v-if="showDrawer">
          <ImportData ref="addOrEdit" v-if="drawerType === 'import'"></ImportData>
          <AddOrEdit
            v-if="drawerType === 'add' || drawerType === 'edit'"
            ref="addOrEdit"
            :gunId="gunId"
            :isEdit="isEdit"
            :editInfo="editInfo"
            :maintainDate="maintainDate"></AddOrEdit>
        </div>
      </ykc-drawer>
      <!--自定义列弹窗 -->
      <ykc-operation-dialog
        title="自定义列"
        show-footer
        :show.sync="show1"
        :before-close="onCLose"
        :before-cancel="beforeCancel"
        :before-confirm="beforeConfirm">
        <div slot="content">
          <el-form
            size="mini"
            label-width="80px"
            ref="customForm"
            class="customForm"
            :model="customForm"
            :rules="customRules">
            <el-form-item label="列选项" prop="checkOption">
              <ykc-checkbox
                :configSet="{
                  label: 'label',
                  value: 'value',
                }"
                :data="customData"
                v-model="customForm.checkOption"
                @change="checkboxChange"></ykc-checkbox>
            </el-form-item>
          </el-form>
        </div>
      </ykc-operation-dialog>
      <ykc-operation-dialog title="二维码" customerWidth="350px" :show.sync="showCode">
        <div slot="content">
          <el-image style="width: 300px; height: 300px" :src="qrcodeImg"></el-image>
        </div>
      </ykc-operation-dialog>
      <ykc-operation-dialog title="链路日志" customerWidth="720px" :show.sync="showLifecycleDialog">
        <div slot="content" v-loading="lifecycleLoading" style="max-height: 65vh; overflow-y: auto">
          <template v-if="lifecycleGroups && lifecycleGroups.length">
            <div class="lifecycle-group" v-for="(g, gi) in lifecycleGroups" :key="'g' + gi">
              <div class="lifecycle-group-head" :class="g.cycleType === 1 ? 'offline' : 'online'">
                <span class="g-cycle">{{ g.cycleType === 1 ? '空闲→离线' : '离线→空闲' }}</span>
                <span class="g-range">
                  {{ formatTraceTime(g.startTime) }} ~ {{ formatTraceTime(g.endTime) }}
                </span>
                <span class="g-duration" v-if="g.durationMs != null">
                  全程 {{ g.durationMs }}ms
                </span>
                <span class="g-trace" v-if="g.traceId">TraceID：{{ g.traceId }}</span>
                <span class="g-trace legacy" v-else>历史数据（未生成TraceID）</span>
              </div>
              <div class="trace-timeline">
                <div class="trace-node" v-for="(n, i) in g.logs" :key="'lc' + gi + '-' + i">
                  <div class="trace-rail">
                    <div
                      class="trace-dot"
                      :class="
                        n.stepStatus === 2 ? 'missing' : n.cycleType === 1 ? 'offline' : 'online'
                      "></div>
                    <div class="trace-line" v-if="i < g.logs.length - 1"></div>
                  </div>
                  <div class="trace-card">
                    <div class="trace-head">
                      <span class="trace-time" v-if="n.createdTime">
                        {{ formatTraceTime(n.createdTime) }}
                      </span>
                      <span class="trace-gap" v-if="n.gapMs != null">
                        距上一步 +{{ n.gapMs }}ms
                      </span>
                      <span
                        class="trace-tag"
                        :class="{ error: n.stepStatus === 0, missing: n.stepStatus === 2 }">
                        {{ n.stepCode }}
                        {{ n.stepStatus === 0 ? '异常' : n.stepStatus === 2 ? '未记录' : '正常' }}
                      </span>
                      <span class="trace-tag cost" v-if="n.costMs != null">
                        本步耗时 {{ n.costMs }}ms
                      </span>
                    </div>
                    <div class="trace-title">{{ n.stepName }}</div>
                    <div class="trace-desc" v-if="stepDesc(n.stepCode)">
                      {{ stepDesc(n.stepCode) }}
                    </div>
                    <div class="trace-detail" v-if="n.reason">{{ n.reason }}</div>
                    <div class="trace-evidence" v-if="n.detailItems && n.detailItems.length">
                      <span class="trace-kv" v-for="item in n.detailItems" :key="item.k">
                        <i>{{ detailKeyDesc(item.k) }}：</i>
                        {{ item.v }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else-if="!lifecycleLoading" class="lifecycle-empty">
            暂无链路日志（日志自功能上线后开始记录）
          </div>
        </div>
      </ykc-operation-dialog>
      <ykc-operation-dialog
        title="插拔枪操作日志"
        customerWidth="680px"
        :show.sync="showPlugDialog">
        <div slot="content" v-loading="plugLoading" style="max-height: 65vh; overflow-y: auto">
          <div style="margin-bottom: 10px; font-weight: 600">
            {{ plugGunName || '-' }}（{{ plugGunCode }}）
          </div>
          <el-table :data="plugRecords" size="small" border>
            <el-table-column label="操作" width="90" align="center">
              <template slot-scope="{ row }">
                <el-tag v-if="row.plugStatus === 1" type="success" size="small">插枪</el-tag>
                <el-tag v-else type="info" size="small">拔枪</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作时间" min-width="160">
              <template slot-scope="{ row }">{{ plugTimeFormat(row.recordTime) }}</template>
            </el-table-column>
            <el-table-column label="来源" width="120" align="center">
              <template slot-scope="{ row }">
                {{ row.changeSource === 2 ? '平台批量下线' : '设备上报' }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 12px; text-align: right"
            background
            layout="total, prev, pager, next"
            :total="plugTotal"
            :page-size="plugPage.size"
            :current-page.sync="plugPage.current"
            @current-change="queryPlugRecords"></el-pagination>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>
<script>
  import QRCode from 'qrcode';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import {
    barrierPage,
    directPage,
    workbench,
    brandModelPage,
    propertySettleManage,
    treeUtils,
  } from '@/service/apis';
  import {
    code,
    localSetItem,
    sessionGetItem,
    localGetItem,
    offlineExport,
    filterMerchantSearch,
  } from '@/utils';

  import AddOrEdit from './AddOrEdit.vue';
  import ImportData from './ImportData.vue';
  import { cloneDeep } from '@/utils/index';

  /** 链路环节详述：每个编号对应人话描述，页面时间线展示用 */
  const LIFECYCLE_STEP_DESC = {
    A1: '通讯层检测到与桩的TCP连接断开（心跳超时/网络异常/桩主动断开），并记录断开现场',
    A3: '设备服务收到由平台生成的离线实时数据，开始执行下线流程',
    A4: '设备服务通过RPC调用电站服务的批量下线接口',
    A5: '电站服务查询该桩下所有枪，逐枪构造状态变更并删除实时状态缓存',
    A6: '枪状态落库、状态变更历史保存、Kafka变位通知发送全部完成',
    B1: '桩重新登录成功，通讯层记录登录现场供链路还原',
    B3: '设备服务收到桩上报的实时状态数据',
    B4: '与缓存中的上次状态比对，状态一致则跳过本次更新（去重）',
    B5: '设备服务通过RPC调用电站服务更新枪状态',
    B6: '电站服务完成枪状态落库、变更历史保存与Kafka变位通知',
  };

  /** 每个循环的预期环节序列：时间线按此补全缺失节点（灰色"未记录"占位，直观暴露流程卡在哪一环） */
  const EXPECTED_LIFECYCLE_STEPS = {
    1: ['A1', 'A3', 'A4', 'A5', 'A6'],
    2: ['B1', 'B3', 'B4', 'B5', 'B6'],
  };

  /** 链路明细字段中文说明 */
  const LIFECYCLE_DETAIL_KEY_DESC = {
    costMs: '本步RPC耗时(ms)',
    dataSource: '数据来源',
    chargeStatus: '充电状态码',
    connectStatus: '插枪状态码',
    changed: '状态是否变化',
    cacheLast: '缓存上次状态',
    newStatus: '本次上报状态',
    beforeStatus: '变更前枪状态',
    afterStatus: '变更后枪状态',
    beforeConnect: '变更前插枪状态',
    afterConnect: '变更后插枪状态',
    historySaved: '变更历史已保存',
    kafkaSent: '变位通知已发送',
    reason: '断开原因',
    remoteIp: '对端IP',
    node: '通讯节点',
    closedTime: '断开时刻',
    idleTime: '心跳超时阈值(ms)',
    loginTime: '登录时刻',
    protocolVersion: '协议版本',
  };

  export default {
    name: 'directConnectionPileList',
    components: {
      AddOrEdit,
      ImportData,
    },
    inject: ['reload'],
    data() {
      return {
        qrcodeImg: '',
        showCode: false,
        showLifecycleDialog: false,
        lifecycleGroups: [],
        lifecycleLoading: false,
        showPlugDialog: false,
        plugLoading: false,
        plugRecords: [],
        plugTotal: 0,
        plugGunCode: '',
        plugGunName: '',
        plugPage: { current: 1, size: 10 },
        gunId: '',
        parName: '',
        parCode: '',
        parkNum: '',
        editInfo: {},
        isProperty: false,
        maintainDate: {
          startTime: null,
          endTime: null,
        },
        drawerType: '',
        show1: false,
        isEdit: false,
        showDrawer: false,
        selectedRows: [], // 选中数据行
        brandListData: [], // 归属电站数据
        OperatorListData: [], // 归属商户数据
        brandAndModelData: [], // 终端型号数据
        propertyData: [], // 物业数据
        addressData: [], // 省市区
        searchParams: {
          code: '',
          name: '',
          stationId: null,
          stationOperator: null,
          statusList: [],
          startStatus: '',
          brandId: '',
          markStatus: '',
          propertyId: '',
          isTestStation: 2, // 2代表全部
          ids: [],
          provinceId: '',
          cityId: '',
          districtId: '',
        },
        pageButtons: [
          {
            id: '0',
            text: '批量操作',
            type: 'plain',
            enabled: () =>
              code('asset:station:diretpile:batchAdd') ||
              code('asset:station:diretpile:batchTiming') ||
              code('asset:station:diretpile:publishQrCode') ||
              code('asset:station:diretpile:exportQrCode'),
            handleClick: () => {
              // this.add();
            },
          },
          {
            id: '1',
            text: '自定义列',
            type: 'plain',
            enabled: () => code('asset:station:diretpile:custom'),
            handleClick: () => {
              this.customColumns();
            },
          },
          {
            id: '2',
            text: '新增',
            type: 'plain',
            enabled: () => code('asset:station:diretpile:add'),
            handleClick: () => {
              this.add();
            },
          },
          {
            id: '3',
            text: '导出',
            type: 'plain',
            enabled: () => code('asset:station:diretpile:export'),
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        customForm: {
          checkOption: [0, 1, 2, 3, 4, 5, 6, 13, 14, 15, 17],
        },
        customData: [
          {
            value: 0,
            label: '终端编码',
          },
          {
            value: 1,
            label: '终端名称',
          },
          {
            value: 13,
            label: '桩类型',
          },
          {
            value: 2,
            label: '归属电站',
          },
          {
            value: 15,
            label: '车位号',
          },
          {
            value: 14,
            label: '功率',
          },
          {
            value: 3,
            label: '终端启停',
          },
          {
            value: 4,
            label: '工作状态',
          },
          {
            value: 17,
            label: '故障原因',
          },
          {
            value: 5,
            label: '归属商户',
          },
          {
            value: 6,
            label: '品牌',
          },
          {
            value: 7,
            label: '维保时间',
          },
          {
            value: 8,
            label: '投运时间',
          },
          {
            value: 9,
            label: '终端型号',
          },
          {
            value: 10,
            label: '型号国标',
          },
          {
            value: 11,
            label: '二维码下发',
          },
          {
            value: 16,
            label: '状态最后更新时间',
          },
        ],
        customRules: {
          checkOption: [{ required: true, message: '请至少选择一个列名称', trigger: 'blur' }],
        },
        tableTitle: '终端列表',
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          {
            label: '终端编码',
            prop: 'gunCode',
            minWidth: '200px',
            id: 0,
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.gunCode} placement="top-start">
            //         <span>{row.gunCode}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          {
            label: '终端名称',
            prop: 'gunName',
            minWidth: '250px',
            id: 1,
            title: false,
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.gunName} placement="top-start">
            //         <span>{row.gunName}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          {
            label: '桩类型',
            prop: 'pileType',
            minWidth: '150px',
            id: 13,
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.pileType === 1 ? '直流 ' : '交流'}</span>;
              },
            },
          },
          {
            label: '归属电站',
            prop: 'stationName',
            minWidth: '250px',
            id: 2,
            title: false,
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.stationName} placement="top-start">
            //         <span>{row.stationName}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          { label: '省', prop: 'provinceName', minWidth: '150px', id: 17 },
          { label: '市', prop: 'cityName', minWidth: '150px', id: 17 },
          { label: '区', prop: 'districtName', minWidth: '150px', id: 17 },
          {
            label: '车位号',
            prop: 'parkNum',
            minWidth: '150px',
            id: 15,
            title: false,
          },
          {
            label: '功率',
            prop: 'pilePower',
            minWidth: '100px',
            id: 14,
            scopedSlots: {
              default: ({ row }) => {
                return `${row.pilePower}KW`;
              },
            },
          },
          {
            label: '终端启停',
            prop: 'startStatus',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                return row.startStatus === 1 ? (
                  <span class={['userStatus', 'status-blue']}>启用</span>
                ) : (
                  <span class={['userStatus', 'status-red']}>停用</span>
                );
              },
            },
            id: 3,
          },
          {
            label: '工作状态',
            prop: 'gunStatus',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const cls = [
                  {
                    color: 'status-black',
                    name: '离线',
                  },
                  {
                    color: 'status-red',
                    name: '故障',
                  },
                  {
                    color: 'status-green',
                    name: '空闲',
                  },
                  {
                    color: 'status-black',
                    name: '充电',
                  },
                  {
                    color: 'status-blue',
                    name: '充电结束',
                  },
                ][row.gunStatus];

                if (!cls) {
                  return '一';
                }

                return <span class={['userStatus', cls.color]}>{cls.name}</span>;
              },
            },
            id: 4,
          },
          { label: '离线/故障持续时间', prop: 'alarmOrOfflineTime', minWidth: '250px', id: 17 },
          { label: '故障原因', prop: 'faultDes', minWidth: '250px', id: 17 },
          { label: '归属商户', prop: 'operatorName', minWidth: '200px', id: 5 },
          { label: '品牌', prop: 'brandName', minWidth: '200px', id: 12 },
          { label: '安装方式', prop: 'installWayName', minWidth: '200px', id: 6 },
          { label: 'sim卡号', prop: 'simNo', minWidth: '200px', id: 18 },
          { label: '维保到期', prop: 'maintenanceEndDate', minWidth: '200px', id: 7 },
          { label: '投运时间', prop: 'userTime', minWidth: '200px', id: 8 },
          { label: '终端型号', prop: 'brandModelName', minWidth: '200px', id: 9 },
          {
            label: '型号国标',
            prop: 'nationalStandard',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.nationalStandard === 1 ? '国标2011' : '国标2015'}</span>;
              },
            },
            id: 10,
          },
          {
            label: '二维码下发',
            prop: 'markStatus',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                // 0：未下发；1：下发成功；2：下发中；3：下发失败'
                const cls = [
                  {
                    color: 'status-black',
                    name: '未下发',
                  },
                  {
                    color: 'status-green',
                    name: '下发成功',
                  },
                  {
                    color: 'status-blue',
                    name: '下发中',
                  },
                  {
                    color: 'status-red',
                    name: '下发失败',
                  },
                ][row.markStatus];

                if (!cls) {
                  return '一';
                }
                return <span class={['userStatus', cls.color]}>{cls.name}</span>;
              },
            },
            id: 11,
          },

          { label: '状态最后更新时间', prop: 'statusChangeTime', minWidth: '200px', id: 16 },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => {
              return true;
            },
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '完成',
            enabled: () => {
              return this.isEdit;
            },
            handler: () => {
              this.$refs.addOrEdit.submitForm().then(() => {
                this.showDrawer = false;
                this.requestList();
              });
            },
          },
          {
            label: '保存',
            enabled: () => {
              return !this.isEdit;
            },
            handler: () => {
              this.$refs.addOrEdit.submitForm().then(() => {
                this.showDrawer = false;
                this.requestList();
              });
            },
          },
        ],
      };
    },
    created() {
      this.stationId = Number(this.$route.query.stationId);
      this.isProperty = JSON.parse(sessionGetItem('propertyFlag'));
      if (this.stationId) {
        this.searchParams.stationId = this.stationId;
      }
      if (this.isProperty) {
        this.searchParams.propertyId = JSON.parse(sessionGetItem('propertyId'));
      }

      const customForm = localGetItem('customForm');

      if (customForm) {
        this.customForm.checkOption = customForm;
        this.tableColumns = this.tableColumns.filter(item => {
          return customForm.includes(item.id);
        });
      } else {
        this.tableColumns = this.tableColumns.filter(item => {
          return ![7, 8, 9, 10, 11].includes(item.id);
        });
      }

      this.requestBrandList();
      this.requestOperatorList();
      this.requestPropertyList();
      this.requestBrandAndModelList();
      this.requestList();
      this.requestGetDistrict();
      this.initData();
    },
    computed: {
      searchData() {
        const all = { id: '', name: '全部' };
        return filterMerchantSearch(
          [
            {
              comName: 'YkcInput',
              key: 'code',
              label: '终端编码',
              placeholder: '请输入终端编码',
            },
            {
              comName: 'YkcInput',
              key: 'name',
              label: '终端名称',
              placeholder: '请输入终端名称',
            },
            {
              comName: 'YkcDropdown',
              key: 'stationId',
              label: '归属电站',
              placeholder: '请选择归属电站',
              data: this.brandListData,
            },
            {
              comName: 'YkcCascader',
              key: 'ids',
              label: '省市区',
              placeholder: '请选择省市区',
              configSet: {
                label: 'name',
                value: 'id',
                children: 'subNodes',
              },
              options: this.addressData,
              filterable: true,
              clearable: true,
              checkStrictly: true,
            },
            {
              comName: 'YkcDropdown',
              key: 'stationOperator',
              label: '归属商户',
              placeholder: '请选择归属商户',
              data: this.OperatorListData,
            },

            {
              comName: 'YkcDropdown',
              key: 'propertyId',
              label: '所属物业',
              placeholder: '请选择所属物业',

              data: this.propertyData,
            },

            {
              multiple: true,
              clearable: true,
              comName: 'YkcDropdown',
              key: 'statusList',
              label: '工作状态',
              placeholder: '请选择工作状态',
              data: [
                { id: '0', name: '离线' },
                { id: '1', name: '故障' },
                { id: '2', name: '空闲' },
                { id: '3', name: '充电中' },
                { id: '4', name: '充电结束' },
              ],
            },
            {
              comName: 'YkcDropdown',
              key: 'startStatus',
              label: '启停状态',
              placeholder: '请选择启停状态',
              data: [
                all,
                ...[
                  { id: '0', name: '停用' },
                  { id: '1', name: '启用' },
                ],
              ],
            },
            {
              remote: true,
              clearable: true,
              comName: 'YkcDropdown',
              key: 'brandId',
              label: '终端型号',
              placeholder: '请选择终端型号',
              data: this.brandAndModelData,
            },
            {
              comName: 'YkcDropdown',
              key: 'markStatus',
              label: '二维码下发',
              placeholder: '请选择二维码下发',
              data: [
                all,
                ...[
                  { id: 0, name: '未下发' },
                  { id: 1, name: '下发成功' },
                  { id: 2, name: '下发中' },
                  { id: 3, name: '下发失败' },
                ],
              ],
            },
            {
              comName: 'YkcInput',
              key: 'parkNum',
              label: '车位号',
              placeholder: '请输入车位号',
            },
            // 商户隐藏筛选项key
          ],
          ['stationOperator', 'propertyId']
        );
      },
      drawerTitle() {
        let txt = '';
        if (this.drawerType === 'add') {
          txt = `直联电桩新增`;
        } else if (this.drawerType === 'edit') {
          txt = `编辑终端`;
        } else if (this.drawerType === 'import') {
          txt = `直联电桩批量新增`;
        }
        return txt;
      },
    },
    methods: {
      code,
      /**
       * 获取区域数据
       */
      requestGetDistrict() {
        treeUtils
          .getDistrict({})
          .then(res => {
            this.addressData = res.districts;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            enabled: () => code('asset:station:diretpile:edit'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  console.log('row++++', row);
                  this.isEdit = true;
                  this.showDrawer = true;
                  this.gunId = row.gunId;
                  this.editInfo = cloneDeep(row);
                  this.maintainDate.startTime = row.maintenanceStartDate;
                  this.maintainDate.endTime = row.maintenanceEndDate;
                  this.drawerType = 'edit';
                }}>
                编辑
              </ykc-button>
            ),
          },
          {
            enabled: () => code('asset:station:diretpile:enable'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.startStatus === 1}
                onClick={() => {
                  this.doAbleActivity(row);
                }}>
                启用
              </ykc-button>
            ),
          },
          {
            enabled: () => code('asset:station:diretpile:enable'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.startStatus === 0}
                onClick={() => {
                  this.doDisableActivity(row);
                }}>
                停用
              </ykc-button>
            ),
          },
          {
            // enabled: () => code('asset:station:privatepile:Timing'),
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doQrcode(row);
                }}>
                查看二维码
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doLifecycleLog(row);
                }}>
                链路日志
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doPlugRecord(row);
                }}>
                插拔记录
              </ykc-button>
            ),
          },
          {
            enabled: () => code('asset:station:diretpile:timing'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doTimingAndPricing(row);
                }}>
                校时/校价
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doClearStatusCache(row);
                }}>
                清除缓存
              </ykc-button>
            ),
          },

          {
            enabled: () => code('asset:station:diretpile:del'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.doDelete(row);
                }}>
                删除
              </ykc-button>
            ),
          },
        ];
      },
      /**
       * 一键清理离线终端状态缓存
       * 拉取当前全部离线终端（gunStatus=0），逐个调用device服务清理 device:gun:status:{gunCode}
       * */
      doClearOfflineCache() {
        // monitorNewPage按桩分组分页，先取第一页拿总桩数，再按总桩数全量拉取
        workbench
          .monitorNewPage({ current: 1, size: 1, gunStatus: 0 })
          .then(firstRes => {
            const total = Number(firstRes && firstRes.total) || 0;
            return workbench.monitorNewPage({ current: 1, size: Math.max(total, 1), gunStatus: 0 });
          })
          .then(res => {
            const gunCodes = [];
            ((res && res.records) || []).forEach(pile => {
              ((pile && pile.groupList) || []).forEach(gun => {
                // 0=离线
                if (gun && gun.status === 0 && gun.gunCode) {
                  gunCodes.push(gun.gunCode);
                }
              });
            });
            if (!gunCodes.length) {
              this.$message.info('未获取到离线终端，无需清理');
              return;
            }
            let successCount = 0;
            Promise.all(
              gunCodes.map(gunCode =>
                directPage
                  .clearGunStatusCache({ gunCode })
                  .then(clearRes => {
                    if (Number(clearRes) > 0) {
                      successCount++;
                    }
                  })
                  .catch(() => {})
              )
            ).then(() => {
              if (successCount === gunCodes.length) {
                this.$message.success(`已清理 ${successCount} 个离线终端缓存`);
              } else if (successCount > 0) {
                this.$message.warning(
                  `共 ${gunCodes.length} 个离线终端，成功清理 ${successCount} 个，其余请重试`
                );
              } else {
                this.$message.error('清理失败，请稍后重试');
              }
              this.requestList();
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 批量处理
       * */
      handleCommand(command) {
        if (command === 'levelConfig') {
          this.drawerType = 'import';
          this.showDrawer = true;
        } else if (command === 'growthValueRule') {
          // 校时/校价
          console.log('P2需求', this.selectedRows);
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunCode);
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '确认批量校时/校价吗？',
              onCancel: done => {
                console.log(done);
                done();
              },
              onConfirm: done => {
                console.log(done);
                directPage
                  .setTimeAndPrice({ gunCodes: params })
                  .then(res => {
                    console.log(res);
                    this.$message.success('批量校时/校价成功');
                    this.requestList();
                  })
                  .catch(err => {
                    console.log(err);
                  });
                done();
              },
            });
          } else {
            this.$message.warning('请选择数据');
          }
        } else if (command === 'clearOfflineCache') {
          // 一键清理缓存：先查询当前离线终端数量，确认后批量清理其状态缓存
          workbench
            .monitorCount({})
            .then(countRes => {
              const offlineNum = Number(countRes && countRes.offLineGunNum) || 0;
              if (!offlineNum) {
                this.$message.info('当前没有离线终端，无需清理');
                return;
              }
              YkcDialog({
                showTitle: false,
                showFooter: true,
                dialogType: 'feedback',
                desc: `当前离线终端 ${offlineNum} 个，确认一键清理其缓存？清理后终端状态将在下一次数据上报时自动恢复。`,
                onCancel: done => {
                  done();
                },
                onConfirm: done => {
                  done();
                  this.doClearOfflineCache();
                },
              });
            })
            .catch(err => {
              console.log(err);
            });
        } else if (command === 'delete') {
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunId);
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '终端删除会连当前电桩下的终端一并删除，删除后不可恢复!',
              onCancel: done => {
                done();
              },
              onConfirm: done => {
                directPage
                  .batchDelete({ ids: params })
                  .then(() => {
                    this.$message.success('删除成功');
                    this.requestList();
                  })
                  .catch(err => {
                    console.log(err);
                  });
                done();
              },
            });
          } else {
            this.$message.warning('请先勾选需要删除的终端后再进行操作');
          }
        } else if (command === 'enable') {
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunId);
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '确定批量启用所选充电桩？',
              onCancel: done => {
                done();
              },
              onConfirm: done => {
                directPage
                  .dirStartSwitch({ gunIdList: params, startStatus: 1 })
                  .then(() => {
                    this.$message.success('启用成功');
                    this.requestList();
                  })
                  .catch(err => {
                    console.log(err);
                  });
                done();
              },
            });
          } else {
            this.$message.warning('请先勾选需要启用的终端后再进行操作');
          }
        } else if (command === 'disable') {
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunId);
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '确定批量停用所选充电桩？',
              onCancel: done => {
                done();
              },
              onConfirm: done => {
                directPage
                  .dirStartSwitch({ gunIdList: params, startStatus: 0 })
                  .then(() => {
                    this.$message.success('停用成功');
                    this.requestList();
                  })
                  .catch(err => {
                    console.log(err);
                  });
                done();
              },
            });
          } else {
            this.$message.warning('请先勾选需要停用的终端后再进行操作');
          }
        } else if (command === 'publishQrCode') {
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunId);
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '确认对于选中的终端进行二维码下发？',
              onCancel: done => {
                done();
              },
              onConfirm: done => {
                directPage
                  .publishQrcode({ gunIds: params })
                  .then(() => {
                    this.$message.success('下发成功');
                    this.requestList();
                  })
                  .catch(err => {
                    console.log(err);
                  });
                done();
              },
            });
          } else {
            this.$message.warning('请选择数据');
          }
        } else if (command === 'exportQrCode') {
          if (this.selectedRows.length > 0) {
            const params = this.selectedRows.map(item => item.gunId);
            offlineExport({
              downloadType: 'gun_mark_export',
              jsonNode: {
                gunIds: params,
              },
            });
          } else {
            this.$message.warning('请选择数据');
          }
        }
      },
      /**
       * 新增
       * */
      add() {
        this.gunId = null;
        this.parName = '';
        this.parCode = '';
        this.drawerType = 'add';
        this.isEdit = false;
        this.showDrawer = true;
      },
      /**
       * @desc 生成二维码
       * */
      doQrcode(row) {
        QRCode.toDataURL(
          `${process.env.VUE_APP_API_URL}/LUOSHU-MP-PAGE/index.html?pNum=${row.gunCode}`
        ).then(url => {
          this.qrcodeImg = url;
          this.showCode = true;
        });
      },
      /**
       * @desc 兼容解析时间：支持毫秒时间戳、"yyyy-MM-dd HH:mm:ss(.SSS)" 字符串（Safari 无法直接 new Date）
       * */
      parseTime(time) {
        if (time == null || time === '') return null;
        if (typeof time === 'number') return time;
        if (typeof time === 'string') {
          const m = time.match(
            /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?/
          );
          if (m) {
            return new Date(
              +m[1],
              +m[2] - 1,
              +m[3],
              +m[4],
              +m[5],
              +m[6],
              m[7] ? +m[7].padEnd(3, '0') : 0
            ).getTime();
          }
        }
        const t = new Date(time).getTime();
        return Number.isNaN(t) ? null : t;
      },
      formatTraceTime(time) {
        const ts = this.parseTime(time);
        if (ts == null) return '—';
        const d = new Date(ts);
        const p = (n, l = 2) => `${n}`.padStart(l, '0');
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(
          d.getMinutes()
        )}:${p(d.getSeconds())}.${p(d.getMilliseconds(), 3)}`;
      },
      /**
       * @desc 链路环节详述文案
       * */
      stepDesc(stepCode) {
        return LIFECYCLE_STEP_DESC[stepCode] || '';
      },
      /**
       * @desc 链路明细字段中文说明
       * */
      detailKeyDesc(key) {
        return LIFECYCLE_DETAIL_KEY_DESC[key] || key;
      },
      /**
       * @desc 插拔枪操作日志：查看当前终端的插枪/拔枪记录
       * */
      doPlugRecord(row) {
        this.plugGunCode = row.gunCode;
        this.plugGunName = row.gunName || '';
        this.plugPage.current = 1;
        this.showPlugDialog = true;
        this.queryPlugRecords();
      },
      queryPlugRecords() {
        this.plugLoading = true;
        directPage
          .plugRecordPage({
            gunCode: this.plugGunCode,
            current: this.plugPage.current,
            size: this.plugPage.size,
          })
          .then(res => {
            this.plugRecords = (res && res.records) || [];
            this.plugTotal = Number(res && res.total) || 0;
          })
          .catch(err => {
            console.log(err);
            this.$message.error('插拔枪操作日志查询失败，请稍后重试');
          })
          .finally(() => {
            this.plugLoading = false;
          });
      },
      plugTimeFormat(time) {
        if (!time && time !== 0) return '-';
        const d = new Date(time);
        if (Number.isNaN(d.getTime())) return time;
        const pad = n => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
          d.getHours()
        )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      },
      /**
       * @desc 链路日志：按终端编码还原 空闲→离线 / 离线→空闲 两个循环的完整路径
       * */
      doLifecycleLog(row) {
        this.lifecycleGroups = [];
        this.lifecycleLoading = true;
        this.showLifecycleDialog = true;
        directPage
          .pileLifecycleLog({ pileCode: row.gunCode, limit: 200 })
          .then(res => {
            const logs = res || [];
            // 明细JSON解析：costMs优先取独立字段，旧数据兜底从detail提取；其余字段key-value展示
            logs.forEach(n => {
              n.detailItems = [];
              let detailCost = null;
              if (n.detail) {
                try {
                  const obj = JSON.parse(n.detail);
                  if (obj && typeof obj === 'object') {
                    Object.keys(obj).forEach(k => {
                      if (k === 'costMs' && obj[k] != null) {
                        detailCost = Number(obj[k]);
                      } else {
                        n.detailItems.push({ k, v: String(obj[k]) });
                      }
                    });
                  } else {
                    n.detailItems.push({ k: '明细', v: String(n.detail) });
                  }
                } catch (e) {
                  n.detailItems.push({ k: '明细', v: String(n.detail) });
                }
              }
              n.costMs = n.costMs != null ? n.costMs : detailCost;
            });
            // 按traceId分组：同一traceId即一次完整状态循环；无traceId的历史数据按循环类型就近归组
            const groups = [];
            let cur = null;
            logs.forEach(n => {
              const key = n.traceId || `__legacy__${n.cycleType}`;
              if (!cur || cur.key !== key) {
                cur = { key, traceId: n.traceId || '', cycleType: n.cycleType, logs: [] };
                groups.push(cur);
              }
              cur.logs.push(n);
            });
            groups.forEach(g => {
              // 组内相邻环节间隔（循环起点无间隔徽标）
              let prevTs = null;
              g.logs.forEach(n => {
                const ts = this.parseTime(n.createdTime);
                n.gapMs = prevTs != null && ts != null ? Math.max(0, ts - prevTs) : null;
                prevTs = ts;
              });
              // 有TraceID的组按预期环节序列补全：缺失环节插入灰色"未记录"占位卡片，
              // 直观暴露流程卡在哪一环（无TraceID的历史数据本就不完整，不做补全）
              if (g.traceId) {
                const byStep = {};
                g.logs.forEach(n => {
                  (byStep[n.stepCode] = byStep[n.stepCode] || []).push(n);
                });
                const merged = [];
                (EXPECTED_LIFECYCLE_STEPS[g.cycleType] || []).forEach(stepCode => {
                  const list = byStep[stepCode];
                  if (list && list.length) {
                    merged.push(...list);
                    delete byStep[stepCode];
                  } else {
                    merged.push({
                      stepCode,
                      stepName: '环节未记录',
                      stepStatus: 2,
                      cycleType: g.cycleType,
                      createdTime: null,
                      gapMs: null,
                      costMs: null,
                      reason:
                        '该环节没有链路记录：可能流程卡在此步之前、失败未被埋点捕获，或链路日志通道丢失数据',
                      detailItems: [],
                    });
                  }
                });
                // 预期序列之外的记录（异常重复/旧编码）追加在尾部，不丢失
                Object.keys(byStep).forEach(stepCode => merged.push(...byStep[stepCode]));
                g.logs = merged;
              }
              // 首尾时间与全程耗时只按真实记录计算（占位节点无时间）
              const realLogs = g.logs.filter(n => n.createdTime);
              g.startTime = realLogs.length ? realLogs[0].createdTime : null;
              g.endTime = realLogs.length ? realLogs[realLogs.length - 1].createdTime : null;
              const s = this.parseTime(g.startTime);
              const e = this.parseTime(g.endTime);
              g.durationMs = s != null && e != null ? Math.max(0, e - s) : null;
            });
            this.lifecycleGroups = groups;
          })
          .catch(err => {
            this.$message.error('链路日志查询失败，请稍后重试');
            console.log(err);
            this.showLifecycleDialog = false;
          })
          .finally(() => {
            this.lifecycleLoading = false;
          });
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'station_pile_export',
            jsonNode: {
              stationType: 1,
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      /**
       * @desc 单个启用
       * */
      doAbleActivity(row) {
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: '确认启用该电桩？',
          onCancel: done => {
            console.log(done);
            done();
          },
          onConfirm: done => {
            console.log(done);
            directPage
              .dirStartSwitch({ gunIdList: [row.gunId], startStatus: 1 })
              .then(res => {
                console.log(res);
                this.$message.success('电桩启用成功');
                this.requestList();
              })
              .catch(err => {
                console.log(err);
              });
            done();
          },
        });
      },
      /**
       * @desc 单个停用
       * */
      doDisableActivity(row) {
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: '点击确认将停用该电桩',
          onCancel: done => {
            console.log(done);
            done();
          },
          onConfirm: done => {
            console.log(done);
            directPage
              .dirStartSwitch({ gunIdList: [row.gunId], startStatus: 0 })
              .then(res => {
                console.log(res);
                this.$message.success('电桩停用成功');
                this.requestList();
              })
              .catch(err => {
                console.log(err);
              });
            done();
          },
        });
      },
      /**
       * @desc 获取勾选id
       * */
      selectionChange(selection) {
        this.selectedRows = [...selection];
      },
      /**
       * @desc 单个校时/校价
       * */
      doTimingAndPricing(row) {
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: '确认对该电桩校时/校价吗？',
          onCancel: done => {
            console.log(done);
            done();
          },
          onConfirm: done => {
            console.log(done);
            directPage
              .setTimeAndPrice({ gunCode: row.gunCode })
              .then(res => {
                console.log(res);
                this.$message.success('校时/校价成功');
                this.requestList();
              })
              .catch(err => {
                console.log(err);
              });
            done();
          },
        });
      },
      /**
       * @desc 清除枪状态去重缓存（修复桩有上报但平台显示离线），二次确认
       * */
      doClearStatusCache(row) {
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: `确认清除终端【${row.gunCode}】的状态缓存吗？`,
          onCancel: done => {
            console.log(done);
            done();
          },
          onConfirm: done => {
            console.log(done);
            done();
            // 二次确认：清除属于数据修复操作，防止误触
            YkcDialog({
              showTitle: false,
              showFooter: true,
              dialogType: 'feedback',
              desc: '清除后该终端下一次状态上报将强制刷新平台显示，请再次确认是否继续？',
              onCancel: secondDone => {
                console.log(secondDone);
                secondDone();
              },
              onConfirm: secondDone => {
                console.log(secondDone);
                directPage
                  .clearGunStatusCache({ gunCode: row.gunCode })
                  .then(res => {
                    console.log(res);
                    this.$message.success(
                      res === 1 ? '状态缓存清除成功' : '未找到该终端的状态缓存（可能已失效）'
                    );
                  })
                  .catch(err => {
                    console.log(err);
                  });
                secondDone();
              },
            });
          },
        });
      },
      /**
       * @desc 单个删除
       * */
      doDelete(row) {
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: '终端删除会连当前电桩下的终端一并删除，删除后不可恢复!',
          onCancel: done => {
            console.log(done);
            done();
          },
          onConfirm: done => {
            console.log(done);
            directPage
              .dirDelete({ gunId: row.gunId })
              .then(res => {
                console.log(res);
                this.$message.success('电桩删除成功');
                this.requestList();
              })
              .catch(err => {
                console.log(err);
              });
            done();
          },
        });
      },
      /**
       * 自定义列
       * */
      customColumns() {
        this.show1 = true;
      },
      /**
       * 组件change方法调用信息提示
       */
      checkboxChange(e) {
        this.customForm.checkOption = e;
        console.log('this.customForm+++', this.customForm);
      },
      /**
       *  弹窗确认
       * */
      beforeConfirm(done) {
        console.log('确认', this.customForm);
        this.$refs.customForm.validate(valid => {
          if (valid) {
            localSetItem('customForm', JSON.stringify(this.customForm.checkOption));
            done();
            this.reload();
          }
        });
      },
      /**
       * 取消操作
       */
      beforeCancel(drawerDone) {
        this.$dialog({
          dialogType: 'feedback',
          showTitle: false,
          closeOnClickModal: false,
          desc: '取消后操作将不被保存，确认是否取消？',
          onConfirm: done => {
            done(); // 关闭弹框
            drawerDone(); // 关闭抽屉
          },
        });
      },
      /**
       * 弹窗关闭
       * */
      onCLose() {
        this.show1 = false;
      },
      /**
       * @desc 关闭抽屉
       * */
      onAddDrawerClose(done) {
        done();
      },
      /**
       * @desc 点击抽屉取消按钮 callback
       * */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            dialogDone();
            drawerDone();
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);
        if (searchData.ids) {
          [this.searchParams.provinceId, this.searchParams.cityId, this.searchParams.districtId] =
            searchData.ids || [];
        }
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        console.log('清空查询', form);
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 获取归属电站列表
       */
      requestBrandList() {
        barrierPage
          .findPriOrPubStations({ type: 1, isPrivatePile: 0 })
          .then(res => {
            console.log('获取归属电站列表+++++', res);
            const params = res;
            params.map(item => {
              return this.brandListData.push({
                id: item.stationId,
                name: item.stationName,
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 获取归属商户列表
       */
      requestOperatorList() {
        directPage
          .userOperatorList({ operatorType: '1' })
          .then(res => {
            const params = res;
            params.map(item => {
              return this.OperatorListData.push({
                id: item.operatorId,
                name: item.name,
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 获取品牌型号列表
       */
      requestBrandAndModelList() {
        brandModelPage
          .brandModelList({ keyword: '' })
          .then(res => {
            console.log('获取品牌型号列表+++++', res);
            res.map(item => {
              return this.brandAndModelData.push({
                id: item.id,
                name: item.modelName,
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 获取物业列表
       */
      requestPropertyList() {
        propertySettleManage
          .propertyList({
            current: 1,
            size: 99999,
          })
          .then(res => {
            console.log('res', res);
            this.propertyData = (res || []).map(item => {
              return {
                id: item.id,
                name: item.propertyName,
              };
            });
            if (this.isProperty) {
              this.searchParams.propertyId = res[0].id;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        directPage
          .dirFindByPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .directConnectionPile-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }

        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  .trace-timeline {
    .trace-node {
      display: flex;

      .trace-rail {
        width: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;

        .trace-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-top: 14px;
          flex-shrink: 0;
          background: #4a7dcc;
        }

        .trace-line {
          width: 2px;
          flex: 1;
          background: #dcdfe6;
          min-height: 22px;
        }
      }

      .trace-card {
        flex: 1;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 10px 14px;
        margin: 0 0 8px 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

        .trace-head {
          display: flex;
          align-items: center;

          .trace-time {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
            font-family: monospace;
          }

          .trace-gap {
            margin-left: 8px;
            font-size: 12px;
            color: #b26a00;
            background: #fdf6ec;
            border: 1px dashed #e6a23c;
            border-radius: 8px;
            padding: 0 6px;
          }

          .trace-tag {
            margin-left: 8px;
            font-size: 12px;
            color: #8a9bbf;
            border: 1px solid #d5deef;
            border-radius: 8px;
            padding: 0 6px;

            &.cost {
              color: #4d8cfd;
              border-color: #c3d6fb;
              background: #f0f6ff;
            }
          }
        }

        .trace-title {
          font-size: 13px;
          font-weight: 600;
          color: #303133;
          margin: 6px 0 4px;
        }

        .trace-desc {
          font-size: 12px;
          color: #909399;
          line-height: 1.6;
        }

        .trace-detail {
          font-size: 12px;
          color: #606266;
          line-height: 1.6;
        }

        .trace-evidence {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
          word-break: break-all;

          .trace-kv {
            display: inline-block;
            margin: 2px 8px 2px 0;

            i {
              font-style: normal;
              color: #b0b6c3;
            }
          }
        }
      }
    }

    .lifecycle-group {
      margin-bottom: 16px;
    }

    .lifecycle-group-head {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 12px;
      margin-bottom: 8px;

      &.offline {
        background: #fdf0ef;
        color: #e54d42;
      }

      &.online {
        background: #eef8f3;
        color: #2ba471;
      }

      .g-cycle {
        font-weight: 600;
        margin-right: 10px;
      }

      .g-range {
        font-family: monospace;
        margin-right: 10px;
      }

      .g-duration {
        margin-right: 10px;
        font-weight: 600;
      }

      .g-trace {
        color: #8a9bbf;

        &.legacy {
          color: #b0b6c3;
        }
      }
    }

    .trace-dot {
      &.offline {
        background: #e54d42;
      }

      &.online {
        background: #2ba471;
      }

      &.missing {
        background: #c8c9cc;
      }
    }

    .trace-tag {
      &.offline {
        background: #fdf0ef;
        color: #e54d42;
      }

      &.online {
        background: #eef8f3;
        color: #2ba471;
      }

      &.error {
        background: #e54d42;
        color: #fff;
      }

      &.missing {
        background: #f2f3f5;
        color: #969799;
        border: 1px dashed #c8c9cc;
      }
    }

    .lifecycle-empty {
      padding: 40px 0;
      text-align: center;
      color: #909399;
      font-size: 13px;
    }
  }
</style>
